import { createContext, useContext, useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const Ctx = createContext({ dark: false, setDark: () => {} });
const initial = () => {
  const s = localStorage.getItem("ic_theme");
  if (s) return s === "dark";
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches || false;
};

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(initial);
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("ic_theme", dark ? "dark" : "light");
  }, [dark]);
  return <Ctx.Provider value={{ dark, setDark }}>{children}</Ctx.Provider>;
}

export const useTheme = () => useContext(Ctx);

export const ThemeToggle = ({ testid = "theme-toggle" }) => {
  const { dark, setDark } = useTheme();
  return (
    <label className="flex shrink-0 items-center gap-1.5 text-xs cursor-pointer" onClick={(e) => e.stopPropagation()}>
      <Sun className="hidden sm:block h-3.5 w-3.5 text-amber-500" />
      <Switch checked={dark} onCheckedChange={setDark} data-testid={testid} aria-label="Dark mode" />
      <Moon className="hidden sm:block h-3.5 w-3.5 text-[#8B6BC9]" />
    </label>
  );
};
